import React from "react";
import { images } from "../../constants";
import { capitalize } from "../../helper/capitalize";
import "./CardProposalNotification.scss";

const CardProposalNotification = ({ proposal }) => {
  const { studentSelected, createddate, status } = proposal;
  const createdDate = new Date(createddate).toLocaleDateString();

  return (
    <div className="notification-public">
      <div className="notification-card">
        <div className="notification-card__icon">
          <img src={images.IconProposalNotification} alt="icon notifications" />
        </div>
        <div className="notification-card__body">
          <h2 className="title-gray-bold-16">
            {studentSelected.studentname} {studentSelected.studentlastname}
          </h2>
          <div className="notification-card__body--sub-info">
            <span className="title-gray-reg-12">
              {capitalize(studentSelected.nationality)}
            </span>
            <span className="title-gray-reg-12">{createdDate}</span>
          </div>
        </div>
        <div className="notification-card__status">
          <button
            className={`btn-notification pending ${status.toLowerCase()}`}
          >
            {status}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardProposalNotification;
